exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ais-Stats {\n  margin: 0 0 40px 0;\n}", ""]);

// exports
